/**
 * @generated SignedSource<<52277e78ef081c4e4b4048272318dc04>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PricingVersion = "VERSION_1" | "VERSION_2";
import { FragmentRefs } from "relay-runtime";
export type productList_subscriptionFragmentMaxProducts$data = {
  readonly subscription: {
    readonly areSalesChannelsEnabled: boolean;
    readonly id: string;
    readonly maxProducts: {
      readonly canAddProduct: boolean;
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
  readonly " $fragmentType": "productList_subscriptionFragmentMaxProducts";
};
export type productList_subscriptionFragmentMaxProducts$key = {
  readonly " $data"?: productList_subscriptionFragmentMaxProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"productList_subscriptionFragmentMaxProducts">;
};

import SubscriptionFragmentMaxProductsRefetchQuery_graphql from './SubscriptionFragmentMaxProductsRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": SubscriptionFragmentMaxProductsRefetchQuery_graphql
    }
  },
  "name": "productList_subscriptionFragmentMaxProducts",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "areSalesChannelsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MaxProducts",
          "kind": "LinkedField",
          "name": "maxProducts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pricingVersion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canAddProduct",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxProducts",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numProducts",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numPublishedProducts",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8aa91cde9d18f36210baf753ba0bbd70";

export default node;
